import Dropdown from './Dropdown';
import FormCheckbox from './FormCheckbox';
import type { VisibilityState } from './dataTableConfig';

export interface ColumnVisibilityOption {
    id: string;
    label: string;
}

interface ColumnVisibilityMenuProps {
    columns: readonly ColumnVisibilityOption[];
    /** DataTable visibility state: a column is shown unless its id maps to `false`. */
    visibility: VisibilityState;
    /** What "Reset" restores. */
    defaultVisibility: VisibilityState;
    onChange: (visibility: VisibilityState) => void;
}

/** Checkbox menu for showing and hiding the columns of a controlled-visibility DataTable. */
const ColumnVisibilityMenu = ({ columns, visibility, defaultVisibility, onChange }: ColumnVisibilityMenuProps) => {
    const visibleCount = columns.filter((column) => visibility[column.id] !== false).length;

    return (
        <Dropdown
            buttonClassName="border border-zinc-700"
            buttonContent={`Columns (${visibleCount}/${columns.length})`}
            // Above DataTable's pinned header and scroll-edge layers (up to z-40), since the menu opens over the table.
            menuClassName="!z-50 max-h-[60vh] w-64 overflow-y-auto"
            position="right"
        >
            <div className="flex items-center justify-between border-b border-zinc-800 px-3 pb-2 pt-1 text-xs">
                <button className="text-blue-400 hover:text-blue-300" type="button" onClick={() => onChange({})}>
                    Show all
                </button>
                <button className="text-blue-400 hover:text-blue-300" type="button" onClick={() => onChange(defaultVisibility)}>
                    Reset
                </button>
            </div>
            <div className="space-y-1.5 px-3 py-2">
                {columns.map((column) => (
                    <FormCheckbox
                        checked={visibility[column.id] !== false}
                        key={column.id}
                        label={column.label}
                        labelClassName="font-normal text-zinc-300"
                        onChange={(event) => onChange({ ...visibility, [column.id]: event.target.checked })}
                    />
                ))}
            </div>
        </Dropdown>
    );
};

export default ColumnVisibilityMenu;
